import styled from "styled-components";
import { Button, Typography } from "antd";
import { colors } from "../../../styles/theme";

/**
 * Wspólne styled components dla modali zamówień
 * Eliminuje duplikację kodu między NewOrderModal i OrderDetailsModal
 *
 * Optymalizacja: Jeden zestaw styled components zamiast dwóch identycznych
 * Wpływ na wydajność: Mniejszy bundle size, łatwiejsze utrzymanie
 */

export const StyledButton = styled(Button)`
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;

  /* Responsywność: Na mobile mniejsza wysokość buttonów */
  @media (max-width: 576px) {
    font-size: 15px;
  }

  &.green-button {
    background: ${colors.success} !important;
    border-color: ${colors.success} !important;
    color: white !important;

    &:hover:not(:disabled) {
      background: ${colors.successHover} !important;
      border-color: ${colors.successHover} !important;
    }
  }

  &.light-green-button {
    background: ${colors.successLight} !important;
    border-color: ${colors.success} !important;
    color: ${colors.successDark} !important;

    &:hover:not(:disabled) {
      background: ${colors.successLighter} !important;
    }
  }

  &.gray-button {
    background: ${colors.gray200} !important;
    border-color: ${colors.gray300} !important;
    color: ${colors.gray700} !important;

    &:hover:not(:disabled) {
      background: ${colors.gray300} !important;
    }
  }

  &.red-button,
  &.finish-button {
    background: ${colors.errorLight} !important;
    border-color: ${colors.errorBorder} !important;
    color: ${colors.error} !important;

    &:hover:not(:disabled) {
      background: ${colors.errorLighter} !important;
    }
  }

  &.ghost-danger-button {
    background: transparent !important;
    border-color: ${colors.error} !important;
    color: ${colors.error} !important;

    &:hover:not(:disabled) {
      background: ${colors.errorLight} !important;
    }
  }

  &.primary-button {
    background: ${colors.primary} !important;
    border-color: ${colors.primary} !important;
    color: white !important;

    &:hover:not(:disabled) {
      background: ${colors.primaryHover} !important;
      border-color: ${colors.primaryHover} !important;
    }
  }
`;

export const OrderSection = styled.div`
  background: ${colors.white};
  border: 1px solid ${colors.gray200};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;

  /* Responsywność: Na mobile mniejszy padding */
  @media (max-width: 576px) {
    padding: 12px;
    margin-bottom: 12px;
  }
`;

export const OrderItem = styled.div`
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  /* Responsywność: Na mobile mniejszy odstęp między itemami */
  @media (max-width: 576px) {
    margin-bottom: 10px;
  }
`;

export const SectionTitle = styled(Typography.Title)`
  font-size: 14px !important;
  font-weight: 600 !important;
  color: ${colors.textBlack} !important;
  margin-bottom: 12px !important;

  /* Responsywność: Na mobile nieznacznie mniejszy font */
  @media (max-width: 576px) {
    font-size: 13px !important;
    margin-bottom: 10px !important;
  }
`;
